export default {
    'warning.capsLock'                    : 'CAPS lock is turn on.',
}